import React from "react";
import styled from "styled-components";
import { colors } from "../theme/colors";
import { gradients } from "../theme/gradients";
import { shadows } from "../theme/shadows";

const PillButton = ({
  children,
  active = false,
  onClick,
  disabled = false,
  variant = "primary",
  className,
  ...props
}) => {
  return (
    <StyledPillButton
      active={active}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      className={className}
      {...props}
    >
      {children}
    </StyledPillButton>
  );
};

const StyledPillButton = styled.button`
  padding: 10px 20px;
  border-radius: 25px;
  border: 2px solid;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  ${({ variant, active }) => {
    if (variant === "primary") {
      return `
        border-color: rgba(255, 255, 255, 0.3);
        color: ${active ? "#333" : "white"};
        background: ${active ? "rgba(255, 255, 255, 0.9)" : "transparent"};

        &:hover:not(:disabled) {
          background: rgba(255, 255, 255, ${active ? "1" : "0.1"});
        }
      `;
    } else {
      return `
        border-color: ${colors.primary.main};
        color: ${active ? "white" : colors.primary.main};
        background: ${active ? colors.primary.main : "transparent"};

        &:hover:not(:disabled) {
          background: ${active ? colors.primary.dark : "rgba(44, 90, 160, 0.1)"};
        }
      `;
    }
  }}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.3);
  }
`;

// Site Group Pill component (specialized variant)
export const SiteGroupPill = styled.span`
  background: ${gradients.siteGroup};
  color: ${colors.siteGroup.color};
  border: 1px solid ${colors.siteGroup.border};
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 0.8em;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: help;
  backdrop-filter: blur(10px);
  box-shadow: ${shadows.sm};
  position: relative;
  overflow: hidden;
  display: inline-block;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.6),
      transparent
    );
  }

  &:hover {
    background: ${gradients.siteGroupHover};
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    border-color: ${colors.siteGroup.borderHover};
  }
`;

export default PillButton;
